import Commons from '../../../Services/Common/Common';

export const M_NOT_BASIC_Schema = {
  mapper: {
    search1: {
      CoCd: (context) => Commons.EncryptAES(context.userInfo?.coCd),
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      SearchText: () => Commons.EncryptAES(''),
    },
    search2: {
      CoCd: (context) => Commons.EncryptAES(context.userInfo?.coCd),
      SearchText: () => Commons.EncryptAES(''),
    },
    search3: {
      CoCd: (context) => Commons.EncryptAES(context.userInfo?.coCd),
    },
    search5: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
    },
  },
};
